/* FindImagesSummaryRenderer.js */

"use strict";

const {Control} = require("@gluenetworks/steve_ui_core");
const {Button} = Control.Action;

/**
 * Renderer for Find Images summary veil.
 * Displays results of getOsUpgradeLinks work execution.
 */
class FindImagesSummaryRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = this._createRootElement();
        this._rootElem.component = this._model;
        this._logger = this._model._logger;

        this._titlePanel = document.createElement("h2");
        this._titlePanel.classList.add("summary-title");
        this._summaryPanel = document.createElement("div");
        this._summaryPanel.classList.add("summary");
        this._errorPanel = document.createElement("div");
        this._errorPanel.classList.add("backup-errors");
        this._errorLabel = document.createElement("div");
        this._errorLabel.classList.add("error-label");
        this._errorLabel.innerHTML = "Platform Errors:";
        this._errorList = document.createElement("div");
        this._errorList.classList.add("error-list");
        this._errorPanel.appendChild(this._errorList);
        this._fillerPanel = document.createElement("div");
        this._fillerPanel.classList.add("filler");
        this._buttonBar = document.createElement("div");
        this._buttonBar.classList.add("summary-buttons");

        this._closeButton = new Button({
            label: "Close",
            darkTheme: true,
        });

        this._registerListeners();
    }

    get rootElement() {
        return this.getRootElement();
    }

    get model() {
        return this.getModel();
    }

    _registerListeners() {
        this._closeButton.on("UserClick", this._onCloseButtonClick.bind(this));
    }

    _unregisterListeners() {
        this._closeButton.removeListener("UserClick", this._onCloseButtonClick);
    }

    shutdown() {
        this._unregisterListeners();
        this._rootElem.remove();

        return this._closeButton
            .shutdown()
            .then(() => {
                this._model = this._rootElem = this._closeButton = undefined;
            })
            .catch(() => {});
    }

    render() {
        return new Promise((resolve) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._titlePanel);
                this._rootElem.appendChild(this._summaryPanel);
                this._rootElem.appendChild(this._errorLabel);
                this._rootElem.appendChild(this._errorPanel);
                this._rootElem.appendChild(this._fillerPanel);
                this._rootElem.appendChild(this._buttonBar);
                this._buttonBar.appendChild(this._closeButton.renderer.rootElement);
                this._displaySummary();
            }
            resolve();
        });
    }

    _setTitle() {
        const data = this._model.summaryData;
        const title =
            data.failureCount === 0
                ? "IoT Platform Images Updated Successfully"
                : data.failureCount === data.total
                ? "IoT Platform Image Update Failed"
                : "IoT Platform Image Update Completed with Errors";
        if (data.failureCount > 0) {
            this._titlePanel.classList.add("error-title");
        } else {
            this._titlePanel.classList.remove("error-title");
        }
        this._titlePanel.innerHTML = title;
    }

    _displaySummary() {
        this._setTitle();

        // Clear summary panel
        while (this._summaryPanel.firstChild) {
            this._summaryPanel.firstChild.remove();
        }

        const data = this._model.summaryData;

        // Total
        const totalLabel = document.createElement("span");
        totalLabel.innerText = `Total IoT Platforms: ${data.total}`;
        this._summaryPanel.appendChild(totalLabel);

        // Success count
        const successLabel = document.createElement("span");
        successLabel.innerText = `Successfully Updated: ${data.successCount}`;
        this._summaryPanel.appendChild(successLabel);

        // Failure count
        const failureLabel = document.createElement("span");
        failureLabel.innerText = `Failed to Update: ${data.failureCount}`;
        this._summaryPanel.appendChild(failureLabel);

        // Skipped count
        if (data.skippedCount > 0) {
            const skippedLabel = document.createElement("span");
            skippedLabel.innerText = `Skipped: ${data.skippedCount}`;
            this._summaryPanel.appendChild(skippedLabel);
        }

        // Work ID
        if (data.workId) {
            const workIdLabel = document.createElement("span");
            workIdLabel.innerText = `Work ID: ${data.workId}`;
            workIdLabel.classList.add("work-id");
            // this._summaryPanel.appendChild(workIdLabel);
        }

        const lineFeed = document.createElement("br");
        this._summaryPanel.appendChild(lineFeed);

        const infoLabel = document.createElement("span");
        infoLabel.innerText = "Results can be viewed in individual IoT Platform activity views.";
        infoLabel.classList.add("info-text");
        this._summaryPanel.appendChild(infoLabel);

        // Clear error list
        while (this._errorList.firstChild) {
            this._errorList.firstChild.remove();
        }

        // Display errors if any
        if (data.failureCount > 0 && data.errors && data.errors.length > 0) {
            this._errorLabel.classList.remove("hidden");
            this._errorPanel.classList.remove("hidden");
            this._fillerPanel.classList.add("hidden");

            data.errors.forEach((error) => {
                const errorMsg = document.createElement("div");
                errorMsg.innerHTML = `<strong>Platform ${error.platformName}</strong>: ${error.message}`;
                errorMsg.classList.add("error-msg");
                this._errorList.appendChild(errorMsg);
            });
        } else {
            this._errorLabel.classList.add("hidden");
            this._errorPanel.classList.add("hidden");
            this._fillerPanel.classList.remove("hidden");
        }
    }

    getRootElement() {
        return this._rootElem;
    }

    getModel() {
        return this._model;
    }

    _createRootElement() {
        const rootElement = document.createElement("find-images-summary-gl");
        rootElement.classList.add("find-images-summary-renderer", "modal_feedback_container");
        rootElement.component = this._model;
        return rootElement;
    }

    _onCloseButtonClick() {
        this._model.close();
    }
}

module.exports = FindImagesSummaryRenderer;
